/* eslint-disable no-unused-vars */
import { Grid, Typography,CircularProgress } from "@mui/material";
import PAutoCompleteMultiSelect from "../../../../components/pos/PAutoCompleteMultiSelect";
import PConfirm from "../../../../components/pos/PConfirm";
import PDialog from "../../../../components/pos/PDialog";
import PText from "../../../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../../utils/API";
import { SyncUtils } from "../../../../utils/SyncUtils";

export default function UserCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState("");
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [username, setUsername] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [currentAddress, setCurrentaddress] = useState("");
  const [currentAddressError, setCurrentaddressError] = useState("");
  const [permanentAddress, setPermanentaddress] = useState("");
  const [permanentAddressError, setPermanentaddressError] = useState("");
  const [contact, setContact] = useState("");
  const [contactError, setContactError] = useState("");
  const [roles, setRoles] = useState([]);
  const [rolesError, setRolesError] = useState("");
  const [availableRoles, setAvailableRoles] = useState([]);
  const [magneticCard, setMagneticCard] = useState([]);
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");

  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.child = {
    showUserCrudWindow: showUserCrudWindow,
  };

  useEffect(() => {
    if (origObject) {
      setWindowTitile(origObject.name);
    }
  }, [origObject]);

  useEffect(() => {
    populateRoles();
  }, []);

  async function populateRoles() {
    let { data } = await API.get("/auth/v1/role/listAll");
    console.log(data);
    let options = [];
    for (let d of data) {
      options.push({ label: d.name, value: d.id });
    }
    setAvailableRoles(options);
  }

  useEffect(() => {
    if (liveValidation && name === "")
      setNameError(translate("Name is Required"));
    else setNameError("");
  }, [name]);
  useEffect(() => {
    if (liveValidation && username === "")
      setUsernameError(translate("Username is Required"));
    else setUsernameError("");
  }, [username]);
  useEffect(() => {
    if (liveValidation && password === "")
      setPasswordError(translate("Password is Required"));
    else setPasswordError("");
  }, [password]);

  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  function showUserCrudWindow(userId) {
    if (userId == null) {
      resetFields();
      setMode("create");
      setLiveValidation(false);
      setOpenWindow(true);
      setWindowTitile(translate("New User"));
    } else {
      setMode("edit");
      populateUser(userId);
    }
  }
  async function populateUser(id) {
    {
      try {
        let { data } = await API.get("/auth/v1/users/" + id);
        setOrigObject(data);
        populateData(data);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive User data from server")
        );
      }
    }
  }

  function populateData(bean) {
    setName(bean.name);
    setUsername(bean.username);
    if (bean.password) setPassword(bean.password);
    else setPassword("**********");
    setEmail(bean.email);
    setCurrentaddress(bean.currentAddress);
    setPermanentaddress(bean.permanentAddress);
    setContact(bean.contact);
    setMagneticCard(bean.magneticCard);
    console.log(bean);
    if (bean.roleJson) {
      setRoles(JSON.parse(bean.roleJson));
    } else {
      setRoles([]);
    }
    //setRoles(bean.roles);
    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setName("");
    setNameError("");
    setUsername("");
    setUsernameError("");
    setPassword("");
    setPasswordError("");
    setEmail("");
    setEmailError("");
    setCurrentaddress("");
    setCurrentaddressError("");
    setPermanentaddress("");
    setPermanentaddressError("");
    setContact("");
    setContactError("");
    setRoles([]);
    setMagneticCard("");
    //setRoles("");
    //setRolesError("");
    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Are You Sure"),
      message:
        translate("Are you sure to delete user") +
        " :" +
        origObject.name +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete("/auth/v1/users/" + origObject.id);
        props.showMessage(
          "warning",
          translate("User") + " " + name + " " + translate("got Removed")
        );
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage("error", translate("Not able to Delete User"));
      }
    }
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/auth/v1/users ", payload);
        props.showMessage("success", translate("Saved Successfully"));
        SyncUtils.requestSync(result.headers);
        props.onRefresh();
        setOpenWindow(false);
        showProgress(false, "Saving");
      } catch (err) {
        showProgress(false, "Saving");
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage("error", translate("Not able to Save User"));
        }
      }
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "name") {
        setNameError(obj.message);
      }
      if (obj.field === "username") {
        setUsernameError(obj.message);
      }
      if (obj.field === "password") {
        setPasswordError(obj.message);
      }
      if (obj.field === "email") {
        setEmailError(obj.message);
      }
      if (obj.field === "currentAddress") {
        setCurrentaddressError(obj.message);
      }
      if (obj.field === "permanentAddress") {
        setPermanentaddressError(obj.message);
      }
      if (obj.field === "contact") {
        setContactError(obj.message);
      }

      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }

    props.showMessage("error", msg.message);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    console.log(mode);
    saveObject["name"] = name;
    saveObject["username"] = username;
    saveObject["password"] = password;
    saveObject["email"] = email;
    saveObject["currentAddress"] = currentAddress;
    saveObject["permanentAddress"] = permanentAddress;
    saveObject["contact"] = contact;
    saveObject["magneticCard"] = magneticCard;

    saveObject["showOnUi"] = true;
    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["version"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["version"] = origObject.version;
    }
    saveObject["roleJson"] = JSON.stringify(roles);
    return saveObject;
  }

  function validate() {
    let flag = true;
    if (!name || name === "") {
      setNameError(translate("Name is Required"));
      flag = false;
    }
    if (!username || username === "") {
      setUsernameError(translate("Username is Required"));
      flag = false;
    }
    if (!password || password === "") {
      setPasswordError(translate("Password is Required"));
      flag = false;
    }
    /*if (!email || email === "") {
      setEmailError("Email is Required");
      flag = false;
    }
    if (!currentAddress || currentAddress === "") {
      setCurrentaddressError("Currentaddress is Required");
      flag = false;
    }
    if (!permanentAddress || permanentAddress === "") {
      setPermanentaddressError("Permanentaddress is Required");
      flag = false;
    }
    if (!contact || contact === "") {
      setContactError("Contact is Required");
      flag = false;
    }
    if (!roles || roles === "") {
      setRolesError("Roles is Required");
      flag = false;
    }*/
    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  function onChanageRole(e, value) {
    console.log(value);
    setRoles(value);
  }

  const content = (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Name")}</Typography>
                </td>
                <td>
                  <PText
                    value={name}
                    error={nameError}
                    onChange={(e) => setName(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("User Name")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={username}
                    error={usernameError}
                    onChange={(e) => setUsername(e.target.value)}
                  ></PText>
                </td>
              </tr>

              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Password")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={password}
                    error={passwordError}
                    type={"password"}
                    onChange={(e) => setPassword(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Roles")}</Typography>
                </td>
                <td>
                  <PAutoCompleteMultiSelect
                    value={roles}
                    options={availableRoles}
                    onChange={onChanageRole}
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Magnetic Card ")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={magneticCard}
                    onChange={(e) => setMagneticCard(e.target.value)}
                  ></PText>
                </td>
              </tr>

              {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12} sm={6}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Contact")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={contact}
                    error={contactError}
                    onChange={(e) => setContact(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Email")}</Typography>
                </td>
                <td>
                  <PText
                    value={email}
                    error={emailError}
                    onChange={(e) => setEmail(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Current Address")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={currentAddress}
                    error={currentAddressError}
                    onChange={(e) => setCurrentaddress(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Permanent Address")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={permanentAddress}
                    error={permanentAddressError}
                    onChange={(e) => setPermanentaddress(e.target.value)}
                  ></PText>
                </td>
              </tr>
            </tbody>
          </table>{" "}
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    if (mode === "create") {
      if (name || name != "") return true;
    }
    if (mode === "edit") {
      if (name !== origObject.name) return true;
    }
    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"md"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          onDelete={onDelete}
          mode={mode}
          isDataChanged={isDataChanged}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
            {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}
    </div>
  );
}
